import React from 'react';

import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main2() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content" style={{background: '#E7ECFF80', position: 'relative', overflow: 'visible'}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="content-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Qui peut <span>en bénéficier ?</span></h2>
                                </div>
                                <div className="text">
                                    <div className="text mt-30">
                                        Cet espace d’échange est réservé <span>aux personnes travaillant chez Boursorama :</span>
                                        <ul className="list-style-three">
                                            <li>Toute personne qui a des questions sur le handicap</li>
                                            <li>Personnes ayant des questions sur des <span>maladies chroniques</span> (exemples:
                                                diabète, problèmes respiratoires, douleurs, hypertension artérielle,
                                                cancer même après guérison…)
                                            </li>
                                            <li>Personnes en situation
                                                de <span>handicap visible ou invisible</span></li>
                                            <li>Tout <span>salarié aidant</span> d’une personne en situation de
                                                handicap
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <ContactModal textButton="Comment ça marche" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false}/>
                            </div>
                        </div>

                        <div className="image-column col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/operatrice.png" alt="opératrice" style={{position: 'absolute', maxWidth: '175%', bottom: '-245px'}} />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main2;
